module.exports = __webpack_public_path__ + "img/sy2.a24c74e3.png";